import { MijnRoute } from '../../mijn-navigatie.model';

export const PENDING_PAYMENTS: MijnRoute = {
    path: 'verzendlijst',
    navigationEvent: 'toPendingPayments',
    regex: /^\/verzendlijst$/,
    webcomponent: 'mijn-pending-payments-webcomponent'
};
